
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { DeleteContacts, EnableContacts } from '@shared/services/api/legacy/contacts-service/contacts-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IList, IListForDropdown, ILists, IListsForDropdown } from './contactqueries-model';

@Injectable()
export class ContactQueriesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${ContactQueriesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/contactqueries';

    public getList(id: string): Observable<SuccessResponse<IList> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IList>>(ContactQueriesService.URL + '/' + id).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getLists(): Observable<SuccessResponse<ILists> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<ILists>>(ContactQueriesService.URL).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getListsForDropdown(): Observable<SuccessResponse<IListsForDropdown> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IListsForDropdown>>(ContactQueriesService.URL + '/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addList(list: IList): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(ContactQueriesService.URL, list).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateList(list: IList): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(ContactQueriesService.URL + '/' + list.id, list).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deleteList(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(ContactQueriesService.URL + '/' + id).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
